<div
  #handle
  class="ant-slider-handle"
  tabindex="0"
  ui-tooltip
  [ngStyle]="style"
  [uiTooltipTitle]="tooltipFormatter === null || tooltipVisible === 'never' ? null : tooltipTitle"
  [uiTooltipTrigger]="null"
  [uiTooltipPlacement]="tooltipPlacement"></div>
